import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { RadioButton } from '../RadioButton';
import { Typography } from '../Typography';
import styles from './RadioButtonWithLabel.module.scss';
import { RadioButtonWithLabelTestIds } from './RadioButtonWithLabel.utils';
export const RadioButtonWithLabel = (param)=>{
    let { id, label, testId, checked, sublabel, disabled, onChange, bi, noBi } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.root,
        "data-testid": testId,
        children: /*#__PURE__*/ _jsx(RadioButton, _object_spread_props(_object_spread({
            id: id,
            testId: testId && RadioButtonWithLabelTestIds.RadioButton(testId),
            onChange: onChange,
            checked: checked,
            disabled: disabled
        }, noBi ? {
            noBi
        } : {
            bi
        }), {
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.label,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: label
                    }),
                    sublabel && /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        children: sublabel
                    })
                ]
            })
        }))
    });
};
